import React from 'react';

// Small "Vague N" tag for a tracker slot. Renders nothing for non-tracker slots.
// `wave` is the slot.survey_wave object ({ label, order_index, ... }).
const VagueBadge = ({ wave, style }) => {
  if (!wave) return null;
  const label = wave.label || `Vague ${(wave.order_index ?? 0) + 1}`;
  return (
    <span
      title={label}
      style={{
        fontSize: '0.55rem',
        fontWeight: 700,
        padding: '2px 6px',
        borderRadius: 3,
        background: '#fef3c7',
        color: '#92400e',
        whiteSpace: 'nowrap',
        ...style,
      }}
    >
      {label}
    </span>
  );
};

export default VagueBadge;
